<template>
	<div>
		<el-form ref="form" label-width="80px">
		  <el-form-item label="更新文件">
		    <el-upload
		      class="upload-demo"
		      :limit="1"
			  ref="upload"
			  action=""
			  :on-change="fileChange"
		      :auto-upload="false">
		      <el-button size="small" type="primary">点击上传</el-button>
		      <div slot="tip" class="el-upload__tip">请上传wgt文件</div>
		    </el-upload>
		  </el-form-item>
		  <el-form-item label="版本号">
		    <el-input v-model="version"></el-input>
		  </el-form-item>
		  <el-form-item>
		      <el-button type="primary" @click="confirmSave">确定</el-button>
		    </el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				version: '',
				fileUid: ''
			}
		},
		methods: {
			fileChange(e) {
				if(e.name.indexOf('.wgt')<0) {
					this.$message({
					  message: '文件格式有误',
					  type: "error"
					});
					this.$refs['upload'].clearFiles()
					return 
				}
				this.fileUid = e.uid
			},
			async confirmSave() {
				if(!this.fileUid) {
					this.$message({
					  message: '请上传补丁文件',
					  type: "error"
					});
					return 
				}
				let filePath = await this.uploadWgt()
				if(!filePath) {
					this.$message({
					  message: '上传失败，请稍后再试',
					  type: "error"
					});
					return 
				}
				let params = {
					filePath,
					version: this.version
				}
				this.$axios.post("ios-version", params).then(res => {
				  if(res.code) {
					  this.$message({
					    message: res.message,
					    type: "success"
					  });
				  }else{
					  this.$message({
					    message: res.message,
					    type: "error"
					  });
				  }
				});
			},
			uploadWgt() {
				let form_data = new FormData();
				form_data.append("file", this.$refs['upload'].getFile({uid: this.fileUid}).raw);
				return this.$axios
				  .post("upload-order", form_data)
				  .then(res => {
					  if(res.code) {
						  return res.data[0]
					  }
					  return null
				  })
				  .catch(e => {
					  this.$message({
					    message: e.message,
					    type: "error"
					  });
					  return null
				  });
			},
			getVersion() {
				this.$axios.get("ios-version").then(res => {
				  console.log(res)
				});
			}
		}, 
		mounted() {
			this.getVersion()
		}
	}
</script>

<style>
</style>